"use client";

import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 */
export const FairTrade = createSVGIcon(
  <>
    <path
      d="M17 14.4795C17 11.9828 12 4 12 4C12 4 7 11.9828 7 14.4795C7 16.9761 9.23858 19 12 19C14.7614 19 17 16.9761 17 14.4795Z"
      fill="#D4D9E4"
    />
    <line x1="3" y1="14.5" x2="21" y2="14.5" stroke="#312921" />
  </>,
  "Fair trade",
  {
    viewBox: "0 0 24 24",
    titleAccess: "Fair Trade",
    fill: "none",
  }
);
